import { object, string } from 'yup';
const contactInformation = object({
  firstName: string().required('Please provide valid first name'),
  lastName: string().required('Please provide valid last name'),
  email: string().required('Please provide valid email address').email('Please provide valid email address'),
  phoneNumber: string().required('Please provide valid phone number').min(10, 'Please provide valid phone number').max(10, 'Please provide valid phone number'),
  street: string().required('Please provide valid current address'),
  street2: string(),
  city: string().required('Please provide valid current city'),
  state: string().required('Please provide valid current state'),
  zipCode: string().required('Please provide valid current zip code').matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Please provide valid current zip code').min(5, 'Please provide valid current zip code').max(10, 'Please provide valid current zip code')
});
export default contactInformation;
//# sourceMappingURL=index.js.map